import { patchEstimateConfirm, } from "@erp/shared/api/generated/wrappers/estimate";
import { postEstimateConfirm, } from "@erp/shared/api/generated/wrappers/estimate";
import { useInvalidateQueries } from "@erp/shared/composables/useInvalidateQueries";
import { queries } from "@erp/shared/queries";
import { showAlert, showResult } from "@erp/shared/utils/dialog";
import { getErrorMessage } from "@erp/shared/utils/error";
import { useMutation } from "@tanstack/vue-query";
export const useEstimateAction = () => {
    const { invalidateQueries } = useInvalidateQueries();
    const createMutation = useMutation({
        mutationFn: async ({ body }) => {
            return await postEstimateConfirm(body);
        },
        onSuccess: () => {
            invalidateQueries([queries.estimate._def, queries.project._def]);
            showResult("견적서 등록 완료", "완료", false, "확인", "닫기");
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "견적서 등록 요청 중 에러 발생");
        },
    });
    const updateMutation = useMutation({
        mutationFn: async ({ id, body, }) => {
            return await patchEstimateConfirm(id, body);
        },
        onSuccess: () => {
            invalidateQueries([queries.estimate._def, queries.project._def]);
            showResult("견적서 수정 완료", "완료", false, "확인", "닫기");
        },
        onError: (err) => {
            showAlert(getErrorMessage(err), "견적서 수정 요청 중 에러 발생");
        },
    });
    return { createMutation, updateMutation };
};
